<div class="app-avatar" [ngClass]="sizeClass">
  @if (imageUrl) {
  <img class="app-avatar__image" [src]="imageUrl" [alt]="name" />
  } @else {
  <span class="app-avatar__initials" aria-hidden="true">{{ initials }}</span>
  }
</div>
